import React, { useEffect, useState } from "react";
import "./Blog.scss";
import DOMPurify from "dompurify";
import axios from "axios";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { GiToaster } from "react-icons/gi";
import { toast } from "react-toastify";

const Addblog = () => {
  const [blogForm, setBlogForm] = useState({
    date: "",
    category: "",
    title: "",
    description: "",
  });
  const [imageData, setDataImage] = useState(null);

  const navigate = useNavigate();

  const sanitizeConfig = {
    ALLOWED_TAGS: [
      "b",
      "i",
      "em",
      "strong",
      "a",
      "img",
      "p",
      "ul",
      "li",
      "ol",
      "br",
      "iframe",
    ],
    ALLOWED_ATTR: ["href", "src", "alt", "title", "target", "style"],
  };

  const sanitizedDescription = DOMPurify.sanitize(
    blogForm.description,
    sanitizeConfig
  );

  const [searchParams] = useSearchParams();
  const location = useLocation();
  const editBlogs = searchParams.get("id");

  const getBlogById = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PORT_BACKEND}blog/getBybId?bId=${editBlogs}`
      );

      const data = response.data.data;

      setBlogForm((prev) => ({
        ...prev,
        date: data?.date,
        category: data?.category,
        title: data?.title,
        description: data?.description,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const id = searchParams.get("id");

    if (id) {
      getBlogById(id);
    }
  }, [location, searchParams]);

  const addBlog = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      const id = searchParams.get("id");
      const blogPayload = {
        ...blogForm,
        bid: Number(id), // 🔥 IMPORTANT: force number
      };

      formData.append("blog", JSON.stringify(blogPayload));
      formData.append("featureimage", imageData);

      let response;
      if (id) {
        response = await axios.put(
          `${process.env.REACT_APP_PORT_BACKEND}blog/updateblog`,
          formData
        );
        toast.success("Blog updated successfully!");
      } else {
        response = await axios.post(
          `${process.env.REACT_APP_PORT_BACKEND}blog/addblog`,
          formData
        );
        toast.success("Blog added successfully!");
      }

      setBlogForm({
        date: "",
        category: "",
        title: "",
        description: "",
      });

      setDataImage(null);
      navigate("/bloglist");
      window.location.reload();
    } catch (err) {
      console.log(err);
      alert("Something went wrong, please try again!");
    }
  };

  return (
    <>
      <div class="add_blog parent">
        <div class="add_blog_form">
          <form action="" onSubmit={addBlog}>
            <div class="form_row">
              <label for=""> Select Image </label>
              <input
                type="file"
                onChange={(e) => setDataImage(e.target.files[0])}
              />
            </div>
            <div class="form_row">
              <label for=""> Select Date </label>
              <input
                type="date"
                value={blogForm.date}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, date: e.target.value });
                }}
              />
            </div>
            <div class="form_row">
              <label for=""> Category </label>
              <input
                type="text"
                value={blogForm.category}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, category: e.target.value });
                }}
              />
            </div>
            <div class="form_row">
              <label for=""> Title</label>
              <input
                type="text"
                value={blogForm.title}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, title: e.target.value });
                }}
              />
            </div>
            <div class="form_row">
              <label for=""> Description</label>
              <div style={{ width: "100%" }}>
                <CKEditor
                  editor={ClassicEditor}
                  data={blogForm.description}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setBlogForm({ ...blogForm, description: data });
                  }}
                  onReady={(editor) => {
                    editor.editing.view.change((writer) => {
                      writer.setStyle(
                        "min-height",
                        "200px",
                        editor.editing.view.document.getRoot()
                      );
                    });
                  }}
                />
              </div>
            </div>
            {/* <div class="form_row">
              <label>Preview:</label>
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitizedDescription,
                }}
              />
            </div> */}
            <div class="form_row">
              <input className="btn" type="submit" />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Addblog;
